<form [formGroup]="form">
  <div class="crud-item-section">
  
    <span>
      <mat-form-field matTooltip="Portable Appliance Testing Days" [matTooltipDisabled]="disabledTooltip(this.portableApplianceTestingDays)">
        <mat-label i18n="@@type.ElectricalAspect.portableApplianceTestingDays">Portable Appliance Testing Days</mat-label>
        <input matInput formControlName="portableApplianceTestingDays" id="portableApplianceTestingDays"              
            (ngModelChange)="portableApplianceTestingDaysChanging($event)" [(ngModel)]="item.portableApplianceTestingDays"              
            (ngModelChange)="portableApplianceTestingDaysChanged($event)" #portableApplianceTestingDays              
            type="number" placeholder="Portable Appliance Testing Days" min="0">
      </mat-form-field>
    </span>

  </div>
</form>